import { api } from "@/lib/api"

/**
 * Datenquelle des Posteingangs.
 *
 * Aus pages/EmailsList.tsx herausgeloest (Schritt G). Steht bewusst in einer
 * eigenen Datei: `EmailItem` leitet sich aus der Antwort ab, und mehrere
 * herausgeloeste Teile brauchen den Typ. Laege er weiter in EmailsList.tsx,
 * importierten die Kinder aus ihrem Elternteil zurueck.
 */
/** So viele Mails holt der Posteingang zuerst; „Ältere laden" holt je so viele dazu. */
export const MAILS_SCHRITT = 200
/** Obergrenze des Backends (`limit` in routes/api_v1/emails/_listing.py). */
export const MAILS_MAX = 2000

export async function fetchEmails(tenant: string, q?: string, direction?: string, postfach?: string, anzahl?: number, ansicht?: string, folder?: string, person?: string) {
  // 🔴 `direction` muss ans Backend, nicht erst clientseitig filtern.
  //
  // Die Liste holt die letzten N Mails nach Datum. Bei Sanitec stehen 2156
  // eingehenden 498 gesendete gegenueber — unter den letzten 200 sind also
  // kaum gesendete. Der Reiter „Gesendet" blieb deshalb praktisch leer,
  // obwohl alle Mails da sind, auch die aus Outlook oder vom Handy
  // (gemeldet 11.08.2026).
  const query: Record<string, unknown> = {
    tenant: tenant || undefined,
    // 🔴 Ohne `anzahl` endete die Liste fest bei 200 Mails — bei Sanitec ist
    // das gut eine Woche, aelter liess sich nicht scrollen (03.10.2026).
    limit: Math.min(MAILS_MAX, Math.max(anzahl ?? 0, q ? 500 : (direction ? 500 : MAILS_SCHRITT))),
  }
  if (q && q.trim()) query.q = q.trim()
  if (direction) query.direction = direction
  // Postfach-Auswahl (mehrere Postfächer je Mandant): leer = alle.
  if (postfach) query.postfach = postfach
  // Reiter offen/meine/wartet (14.10.2026): Arbeitsliste nach der Review-Regel.
  if (ansicht) query.ansicht = ansicht
  // Personen-Filter (#198): mit ansicht=meine die offenen Mails dieser Person.
  if (ansicht === "meine" && person) query.person = person
  // Ordner „Spam" (16.10.2026): alle Spam-/Junk-Ordner aller Postfächer —
  // vom Server gefiltert, damit auch ältere Spam-Mails in der Liste stehen.
  if (folder) query.folder = folder
  const { data, error } = await api.GET("/api/v1/emails", {
    params: { query: query as never },
  })
  if (error) throw new Error(String(error))
  return data
}

export type EmailItem = NonNullable<Awaited<ReturnType<typeof fetchEmails>>>["items"][number]
